import React, { Component } from "react";
import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";
import "react-images-uploader/styles.css";
import Video from "./unit/Video";
import Youtube from "./unit/Youtube";
import Audio from "./unit/Audio";
import { Link } from "react-router-dom";

export default class CreateCourse extends Component {
  state = {
    enableCourseName: false,
    enableCourseDisc: false,
    courseName: "Give your course a name",
    courseDisc:
      "Add a description of your course. Keep it clear and interesting for your learners.",
    selectedUnitType: 0,
    selectedOption: 1,
    unitTypes: [
      { id: 1, unitName: "Video", unitIcon: <i class="fas fa-video"></i> },
      { id: 2, unitName: "Youtube", unitIcon: <i class="fab fa-youtube"></i> },
      { id: 3, unitName: "Audio", unitIcon: <i class="fas fa-microphone"></i> },
      { id: 4, unitName: "Quiz", unitIcon: <i class="fas fa-question"></i> },
      { id: 5, unitName: "Live Class", unitIcon: <i class="fas fa-wifi"></i> },
      { id: 6, unitName: "Course", unitIcon: <i class="fas fa-bars"></i> },
    ],
    trainerOptions: [
      {
        id: 1,
        name: "CONTENT",
        subname: "0 inactive",
        icons: <i class="fas fa-th"></i>,
      },
      {
        id: 2,
        name: "USERS & PROGRESS",
        subname: "1 instructor · 0 learners",
        icons: <i class="fas fa-user"></i>,
      },
      {
        id: 3,
        name: "FILES",
        subname: "0 files",
        icons: <i class="fas fa-folder-open"></i>,
      },
      {
        id: 4,
        name: "RULES & PATH ",
        subname: "Sequential rule set",
        icons: <i class="fas fa-chart-line"></i>,
      },
      {
        id: 5,
        name: "REPORTS",
        subname: "No Reports",
        icons: <i class="fas fa-chart-pie"></i>,
      },
    ],
  };
  enableCourseName = () => {
    this.setState({ enableCourseName: true });
  };
  enableCourseDisc = () => {
    this.setState({ enableCourseDisc: true });
  };
  closeNameEditing = () => {
    this.setState({ enableCourseName: false });
  };
  closeDiscEditing = () => {
    this.setState({ enableCourseDisc: false });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSelectUnit = (id) => {
    this.setState({ selectedUnitType: id });
  };
  onSelectedOptions = (id) => {
    this.setState({ selectedOption: id });
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container create-course border shadow-sm p-0 bg-white">
          {/* <div className="header bg-primary p-3 text-white">
            Home / <b> </b>
          </div> */}
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> / <b>Course Name</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 left-section border-right">
              <div className="row p-2 m-0">
                <div className="col-md-2">
                  <ImagesUploader
                    url="http://localhost:9090/notmultiple"
                    optimisticPreviews
                    multiple={false}
                    onLoadEnd={(err) => {
                      if (err) {
                        console.error(err);
                      }
                    }}
                  />
                </div>
                <div className="col-md-10 d-flex justify-content-center flex-column">
                  {this.state.enableCourseName ? (
                    <div className="row">
                      <input
                        type="text"
                        className="form-control mt-1"
                        style={{ width: "80%" }}
                        placeholder="Enter Course Name"
                        name="courseName"
                        value={this.state.courseName}
                        onChange={this.onInputChange}
                      />
                      <div className="d-flex justify-content-center align-items-center">
                        <i
                          className="fa fa-check text-success mx-1 cursor-pointer"
                          onClick={this.closeNameEditing}
                        ></i>
                        <i
                          className="fa fa-times text-danger mx-1 cursor-pointer"
                          onClick={this.closeNameEditing}
                        ></i>
                      </div>
                    </div>
                  ) : (
                    <h4>
                      {this.state.courseName}{" "}
                      <span>
                        <i
                          class="fas fa-pencil-alt text-primary ml-1"
                          onClick={this.enableCourseName}
                        ></i>
                      </span>
                    </h4>
                  )}

                  {this.state.enableCourseDisc ? (
                    <div className="row">
                      <textarea
                        type="text"
                        className="form-control mt-1"
                        style={{ width: "80%" }}
                        placeholder="Enter Course Discription"
                        name="courseDisc"
                        value={this.state.courseDisc}
                        onChange={this.onInputChange}
                      />
                      <div className="d-flex justify-content-center align-items-center">
                        <i
                          className="fa fa-check text-success mx-1 cursor-pointer"
                          onClick={this.closeDiscEditing}
                        ></i>
                        <i
                          className="fa fa-times text-danger mx-1 cursor-pointer"
                          onClick={this.closeDiscEditing}
                        ></i>
                      </div>
                    </div>
                  ) : (
                    <p className="m-0">
                      {this.state.courseDisc}{" "}
                      <i
                        class="fas fa-pencil-alt text-primary"
                        onClick={this.enableCourseDisc}
                      ></i>
                    </p>
                  )}
                </div>
              </div>
              <div className="p-2 my-2">
                <h5>Select Course Type</h5>
                <div className="d-flex">
                  {this.state.unitTypes.map((type) => (
                    <div className="m-2">
                      <div
                        className={`card card-selector shadow-sm p-2 ${
                          type.id == this.state.selectedUnitType
                            ? "selected"
                            : ""
                        }`}
                        onClick={this.onSelectUnit.bind(this, type.id)}
                      >
                        <div className="d-flex justify-content-center align-items-center flex-column">
                          <div className="icon">{type.unitIcon}</div>
                          {type.unitName}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="unit-container">
                <div className="p-2 my-2">
                  {this.state.selectedUnitType == 1 ? (
                    <Video></Video>
                  ) : this.state.selectedUnitType == 2 ? (
                    <Youtube></Youtube>
                  ) : this.state.selectedUnitType == 3 ? (
                    <Audio></Audio>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 right-section pl-0">
              {this.state.trainerOptions.map((option) => (
                <div
                  onClick={this.onSelectedOptions.bind(this, option.id)}
                  className={`card card-selector shadow-sm p-2 m-2 ${
                    option.id == this.state.selectedOption ? "selected" : ""
                  }`}
                >
                  <div className="row">
                    <div className="col-2">
                      <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                        {option.icons}
                      </div>
                    </div>
                    <div className="col-10">
                      <div className="text d-flex flex-column">
                        <h5 className="m-0 btn-link">{option.name}</h5>
                        <p className="m-0">{option.subname}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
